import React, { useState, useEffect } from "react";
import Hamburger from "./components/Hamburger";
import HeaderComponents from "./components/HeaderComponents";
import SideNav from "./components/SideNav";
import Home from "./Home";
import ScrollTopButton from "./components/ScrollTopButton";
import Logo from "./components/Logo";
import feedgramLogo from "./branding/thefeedgram.svg";
// import { Redirect, Link } from "found";
import { Link } from "react-router-dom";
import environment from "./Environment";
import { commitLocalUpdate } from "react-relay";
import "./HomeView.css";
import { useTheme } from "./contexts/ThemeContext";
import SmallScreenHamburger from "./components/SmallScreenHamburger";
import FullSpanMenuModal from "./components/FullSpanMenuModal";
import { updateLocalSetting } from "./Environment";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import Banner from "react-js-banner";
import AccountDetailsContainer from "./AccountDetailsContainer";
import Joyride from "react-joyride";
import { useMediaQuery } from "react-responsive";
import { useNavigate, useLocation } from "react-router-dom";

function HomeView(props) {
    let [scrolled, setScrolled] = useState(window.pageYOffset);
    let [coords, setCoords] = useState(document.documentElement.clientHeight);
    const [showHeader, setShowHeader] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const isCompactScreen = useMediaQuery({
        query: "(max-width: 1110px)",
    });

    const [isFullSpanModalActive, setIsFullSpanModalActive] = useState(false);
    const [showReload, setShowReload] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();

    const [steps, setSteps] = useState([
        {
            target: ".my-initial-step",
            title: "Toggle Side Nav",
            content:
                "The folders and Sources you have added will appear here. Select different sources after adding them to view contained posts.",
        },
        {
            target: ".my-first-step",
            title: "Add Folder",
            content:
                "Start by adding a new folder. A folder is a way to organize your favorite sources by category.",
        },
        {
            target: ".my-second-step",
            title: "Add Sources",
            content:
                "Add your favorite feeds from the list of sources by clicking this button.",
        },
        {
            target: ".my-third-step",
            title: "Bookmarked Posts",
            content:
                "You can find your bookmarked posts here. To bookmark a post, select Add bookmark from the 'three dots menu' below each post.",
        },
        {
            target: ".my-fourth-step",
            title: "Annotated Posts",
            content:
                "Click here to view all the posts that you have added notes to it.",
        },
        {
            target: ".my-fifth-step",
            content: "",
        },
        {
            target: ".my-sixth-step",
            title: "Analyze Articles",
            content:
                "Click this icon to analyze your posts and find Topic Trends, Positive, Negative, or Neutral posts and, Advanced Search.",
        },
        {
            target: ".my-seventh-step",
            title: "Search Posts",
            content:
                "Click here for Quickly Filtering posts from your selected feed or folder.",
        },
        {
            target: ".my-eighth-step",
            title: "Settings Menu",
            content:
                "Find all your Settings, Profile, Account, and Subscription details, and select your favorite Theme and more from here. Happy reading!!!",
        },
    ]);
    const onSWUpdate = (registration) => {
        setShowReload(true);
        setWaitingWorker(registration.waiting);
    };

    useEffect(() => {
        const handlePopState = (event) => {
            event.preventDefault();
            commitLocalUpdate(environment, (store) => {
                const record = store.getRoot().getLinkedRecord("settings");
                record.setValue(false, "isRightNavActivated");
            });
            console.log("popstate from HomeView");
            if (location.pathname === "/home") {
                navigate(location.pathname);
            }
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    useEffect(() => {
        serviceWorkerRegistration.register({ onUpdate: onSWUpdate });
    }, []);

    const reloadPage = () => {
        waitingWorker.postMessage({ type: "SKIP_WAITING" });
        setShowReload(false);
        window.location.reload(true);
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = (e) => {
        e.preventDefault();

        if (window.pageYOffset + 500) {
            setScrolled(window.pageYOffset + 500);
        }
    };

    useEffect(() => {
        if (isFullScreenMenuActivated) {
            setIsFullSpanModalActive(true);
        }
        if (isFullSpanModalActive) {
            // updateLocalSetting("isFullScreenMenuActivated", isFullSpanModalActive);
        }
    });

    // useEffect(() => {
    // 	if(isSmallScreen) {

    // 	}
    // })

    const user = props.user;
    const { email, is_premium, payment_status, first_time_user } = props.user;
    const {
        isAuthenticated,
        userId,
        isNavActivated,
        selectedSourceId,
        isDetailView,
        isFullScreenMenuActivated,
    } = props.settings;

    const settings = props.settings;

    useEffect(() => {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(false, "isDetailView");
        });
    });

    const userHome = (
        <div className={`main-home-container`}>
            <Home
                user={props.user}
                settings={props.settings}
                selectedSourceId={selectedSourceId}
                navbarState={isNavActivated}
            />
            <ScrollTopButton />
        </div>
    );

    useEffect(() => {
        if (scrolled > coords) {
            setShowHeader(true);
        } else {
            setShowHeader(false);
        }
        // let showHeader = scrolled > coords ? "true" : "false";
    });

    return (
        <div className={`home-view-container theme-${theme.light}`}>
            <Snackbar
                open={showReload}
                message="A new version is available!"
                onClick={reloadPage}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                action={
                    <Button color="inherit" size="small" onClick={reloadPage}>
                        Reload
                    </Button>
                }
            />
            {first_time_user && !isCompactScreen ? (
                <div>
                    <Joyride
                        steps={steps}
                        styles={{
                            options: {
                                arrowColor: "azure",
                                backgroundColor: "azure",
                                overlayColor: "rgba(25, 0, 0, 0.32)",
                                primaryColor: "red",
                                textColor: "black",
                                width: 300,
                                height: 200,
                                zIndex: 1000,
                                paddingTop: 300,
                                showSkipButton: true,
                            },
                        }}
                    />
                </div>
            ) : null}
            {payment_status === "past_due" ? (
                <div>
                    <Banner
                        css={{
                            height: "0.6rem",
                            backgroundColor: "lightgoldenrodyellow",
                        }}
                    >
                        <div>
                            <AccountDetailsContainer
                                settings={props.settings}
                                user={props.user}
                                title={`Payment incomplete! Update billing info.`}
                                style={{
                                    fontSize: "1.2rem",
                                    color: "orangered",
                                }}
                            />
                        </div>
                    </Banner>
                </div>
            ) : null}
            <div
                className={`header-${isNavActivated} theme-${
                    theme.light
                } theme-${
                    theme.border + "-" + showHeader
                } header header-fixed-${showHeader}`}
            >
                <div
                    className={`home-header-room theme-${theme.light} header-room-${showHeader}`}
                >
                    {!isSmallScreen ? (
                        <>
                            <div
                                className={`logo-box logo-box-${isNavActivated}`}
                            >
                                <div className="hamburger-container">
                                    <span>
                                        <Hamburger
                                            isActivated={isNavActivated}
                                        />
                                    </span>
                                </div>
                                <img
                                    className="brand-logo"
                                    src={feedgramLogo}
                                    alt=""
                                />
                            </div>
                        </>
                    ) : (
                        <div className={`logo-box logo-box-false`}>
                            <div className="hamburger-container">
                                <span>
                                    <SmallScreenHamburger
                                        isActivated={isFullScreenMenuActivated}
                                        settings={settings}
                                    />
                                </span>
                            </div>
                            <img
                                className="brand-logo"
                                src={feedgramLogo}
                                alt=""
                            />
                        </div>
                    )}

                    <div className="home-component-box">
                        <HeaderComponents
                            view="home"
                            settings={settings}
                            user={props.user}
                        />
                    </div>
                </div>
            </div>
            {isSmallScreen ? (
                <div>
                    {isFullScreenMenuActivated ? (
                        <div>
                            <FullSpanMenuModal
                                isModalActive={true}
                                user={user}
                                settings={settings}
                            />
                        </div>
                    ) : null}
                </div>
            ) : null}
            <SideNav
                isActivated={isNavActivated}
                user={user}
                settings={props.settings}
            />{" "}
            <div className={`theme-${theme.light} home-body-${true}`}>
                {isAuthenticated ? userHome : null}
                {!isAuthenticated ? <Link to="/login" /> : null}
            </div>
        </div>
    );
}

export default HomeView;
